import { Modal } from "antd";
import React, { useState } from "react";
import ConfigPadraoValorRequest from "../../ConfigPadraoValorRequest";
import { ModalStatusDelete } from "../../../../Utils/modalStatus";

export const ModalDelete = ({ visible, onCancel, id, estadoConfig }) => {
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [openModalStatus, setOpenModalStatus] = useState(false);

  const deleteConfig = async () => {
    setConfirmLoading(true);
    try {
      const response = await ConfigPadraoValorRequest.ExcluirConfigPadraoValor(
        id
      );
      if (response.status === 204) {
        onCancel();
        estadoConfig((prevState) => prevState.filter((item) => item.id !== id));
        setConfirmLoading(false);
        setOpenModalStatus(true);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setConfirmLoading(false);
    }
  };

  return (
    <>
      <Modal
        visible={visible}
        onCancel={onCancel}
        onOk={deleteConfig}
        confirmLoading={confirmLoading}
      >
        <text style={{ fontWeight: "500", fontSize: 16 }}>
          Deseja realmente excluir esta Config. Padrão Valor?
        </text>
      </Modal>

      <ModalStatusDelete
        onCancel={() => setOpenModalStatus(false)}
        visible={openModalStatus}
      />
    </>
  );
};
